<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2"><b>Step 3.</b> Next:</p>

      <p>
        Add
        <v-select
          v-model="inputs.input1"
          class="my-1"
          style="display: inline-block; width: 12em"
          outlined
          :items="options"
          item-text="text"
          item-value="value"
        >
          <template #item="{item}">
            <stemble-latex class="no-text-transform" :content="item.text" />
          </template>
          <template #selection="{item}">
            <stemble-latex class="no-text-transform" :content="item.text" />
          </template>
        </v-select>
        until the cloudiness persists -
        <i>continue to swirl and keep warm.</i>
        Then, add
        <v-select
          v-model="inputs.input2"
          class="my-1"
          style="display: inline-block; width: 12em"
          outlined
          :items="options"
          item-text="text"
          item-value="value"
        >
          <template #item="{item}">
            <stemble-latex class="no-text-transform" :content="item.text" />
          </template>
          <template #selection="{item}">
            <stemble-latex class="no-text-transform" :content="item.text" />
          </template>
        </v-select>
        of ethanol until the cloudiness disappears.
      </p>

      <p class="mb-2"><b>Step 4.</b> Next:</p>
      <p>
        Allow the solution to cool to
        <v-select
          v-model="inputs.input3"
          class="my-1"
          style="display: inline-block; width: 12em"
          outlined
          :items="options"
          item-text="text"
          item-value="value"
        >
          <template #item="{item}">
            <stemble-latex class="no-text-transform" :content="item.text" />
          </template>
          <template #selection="{item}">
            <stemble-latex class="no-text-transform" :content="item.text" />
          </template>
        </v-select>
        .
      </p>
      <!--image-->
      <p>(image placeholder)</p>

      <p>While waiting, chill a small beaker of water in an ice bath.</p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';
import STextarea from '@/common/components/STextarea.vue';
import {seededShuffle} from '@/courses/utils/seededShuffle';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'ChemUCI51lbA5_Q11c',
  components: {ChemicalLatex, StembleLatex, STextarea},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
        input2: null,
        input3: null,
      },
      options: [
        {text: 'EtOH', value: 'EtOH'},
        {text: '~20 mL', value: '20ml'},
        {text: '$70^{\\circ}\\text{C}$', value: '70oC'},
        {text: 'crude product', value: 'crudeProduct'},
        {text: 'minimum', value: 'minimum'},
        {text: 'DI water', value: 'DIwater'},
        {text: 'drops', value: 'drops'},
        {text: 'room temperature', value: 'roomTemp'},
        {text: '15 minutes', value: '15min'},
        {text: 'melting point', value: 'meltingPoint'},
        {text: 'standards', value: 'standards'},
      ],
    };
  },
  computed: {
    seed() {
      return this.$inertia.getSeed();
    },
    optionsShuffled() {
      return seededShuffle(this.options, this.seed);
    },
  },
};
</script>
